import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ServiceModel } from 'src/app/models/service-model';
import { ServiceService } from 'src/app/services/service.service';

@Component({
  selector: 'app-service-edit',
  templateUrl: './service-edit.component.html',
  styleUrls: ['./service-edit.component.scss']
})
export class ServiceEditComponent implements OnInit {
  public serviceId: number = 0;
  public service: ServiceModel = {
    id: 0,
    name: ''
  };

  constructor(private _modal: NgbActiveModal,  private _toastService: ToastrService, private _serviceService: ServiceService) { }

  async ngOnInit(): Promise<void> {
    if (this.serviceId !== 0) {
      let services = await this._serviceService.GetServices();
      this.service = services.find(x => x.id == this.serviceId);
    }
  }

  public close() {
    this._modal.close();
  }

  public async save(): Promise<void> {
    const result = await this._serviceService.EditService(this.service);
    if (result.success) {
      this._toastService.success('Service updated successfully','Updated');
      this.close();
    }else {
      this._toastService.error('Could not update service','Error');
    }
    return;
  }
}
